/* PDP v3 (2026-09-26) — vertical accordion helpers for sections/ame-pdp-main.liquid.
   The sections are native <details>/<summary>, so opening, closing, keyboard activation and the expanded
   state need no script. This file only makes in-page links land on content inside a closed section:
     • a[href^="#tab-"] and [data-jump-to-tab] links open the enclosing <details>, then scroll to it;
     • a URL hash that points inside a section opens it on load;
     • window.AmeAcc.reveal(el) is shared with assets/ame-pdp-state.js (fabric / specs jumps).
   The FAQ question toggles inside the FAQ section are unchanged. */
(function () {
  function reveal(el) {
    var d = el && el.closest ? el.closest('details') : null;
    while (d) { d.open = true; d = d.parentElement ? d.parentElement.closest('details') : null; }
  }
  window.AmeAcc = { reveal: reveal };

  function targetFor(link) {
    var id = link.getAttribute('data-jump-to-tab');
    if (!id) { var href = link.getAttribute('href') || ''; if (href.charAt(0) === '#') id = href.slice(1); }
    return id ? document.getElementById(id) : null;
  }
  document.addEventListener('click', function (e) {
    var link = e.target.closest ? e.target.closest('a[href^="#tab-"], [data-jump-to-tab]') : null;
    if (!link) return;
    var panel = targetFor(link);
    if (!panel) return;
    e.preventDefault();
    window.AmeAcc.reveal(panel);   // the tabs controller below wraps this to activate the group's tab first
    // 2026-10-16: a link to a sub-section (#tab-warranty inside Delivery & Support) lands on that sub-section's own box, not
    // on the group's top; a link to the group itself (the content navigator) lands on the group.
    var box = panel.matches('details') ? panel : (panel.closest('.ame-acc__sub') || panel.closest('details') || panel);
    requestAnimationFrame(function () {
      box.scrollIntoView({ behavior: 'smooth', block: 'start' });
      var sum = box.matches('details') ? box.querySelector('summary') : null;
      if (sum) sum.focus({ preventScroll: true });
      else if (box.querySelector) { var h = box.querySelector('h3, h2'); if (h) { if (!h.hasAttribute('tabindex')) h.setAttribute('tabindex', '-1'); h.focus({ preventScroll: true }); } }
    });
  });

  function openFromHash() {
    if (!location.hash || location.hash.length < 2) return;
    var el = null;
    try { el = document.getElementById(decodeURIComponent(location.hash.slice(1))); } catch (err) { el = null; }
    if (el) window.AmeAcc.reveal(el);
  }
  openFromHash();
  window.addEventListener('hashchange', openFromHash);

  // FAQ accordion (questions inside the FAQ section)
  document.querySelectorAll('.ame-faq__question').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var expanded = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', String(!expanded));
      var answer = document.getElementById(this.getAttribute('aria-controls'));
      if (answer) answer.classList.toggle('is-open');
    });
  });
})();

/* 2026-10-16 (two-stage experience, brief §2) — six grouped sections. On phones they are the native accordions they always
   were (Overview open; what the shopper opens stays open through a rotate). From 990px, when the section rendered a tab row
   ([data-pdp-tabs]), the SAME groups become real tab panels: one visible at a time under a keyboard-operable tablist
   (roving tabindex, Left/Right/Home/End, automatic activation). Nothing is duplicated or removed — the group's <details>
   is the panel's host, its heading is hidden by CSS and the tab is the accessible name. An in-page link or a URL hash
   into a group activates its tab (window.AmeAcc.reveal), so "Watch the video" and "#tab-warranty" keep working. Without
   a tab row (any other template) the desktop behaviour is unchanged: every group open. */
(function () {
  var info = document.querySelector('.ame-info[data-pdp-sections]');
  var groups = Array.prototype.slice.call(document.querySelectorAll('details.ame-acc--group'));
  if (!groups.length) return;
  var tabsEl = document.querySelector('[data-pdp-tabs]');
  var tabs = tabsEl ? Array.prototype.slice.call(tabsEl.querySelectorAll('[role="tab"]')) : [];
  var mq = window.matchMedia('(min-width: 990px)');
  var defaults = groups.map(function (d) { return d.hasAttribute('data-default-open'); });
  var byId = {}; groups.forEach(function (d) { byId[d.id] = d; });
  var tabFor = function (d) { return tabs.filter(function (t) { return t.getAttribute('aria-controls') === d.id; })[0]; };
  var bodyOf = function (d) { return d.querySelector(':scope > .ame-acc__body'); };
  var isTabs = function () { return mq.matches && tabs.length > 0; };
  var active = null, wasDesktop = null;

  function activate(id, focusTab) {
    if (!isTabs() || !byId[id]) return;
    active = id;
    groups.forEach(function (g) {
      var t = tabFor(g), on = g.id === id;
      g.open = true;
      g.hidden = !!t && !on;          // a group without a tab (none today) simply stays visible
      if (t) { t.setAttribute('aria-selected', on ? 'true' : 'false'); t.tabIndex = on ? 0 : -1; }
    });
    if (focusTab) { var ft = tabFor(byId[id]); if (ft) ft.focus(); }
    document.dispatchEvent(new CustomEvent('ame:tabs:change', { detail: { id: id } }));
  }
  function apply() {
    var desktop = mq.matches;
    if (wasDesktop === desktop) return;
    wasDesktop = desktop;
    if (isTabs()) {
      if (info) info.classList.add('is-tabs');
      groups.forEach(function (g) {
        var t = tabFor(g), b = bodyOf(g);
        if (t && b) { b.setAttribute('role', 'tabpanel'); b.setAttribute('aria-labelledby', t.id); b.setAttribute('tabindex', '0'); }
      });
      var first = groups.filter(function (g, i) { return defaults[i]; })[0] || groups[0];
      activate(active || first.id, false);
    } else {
      if (info) info.classList.remove('is-tabs');
      groups.forEach(function (g, i) {
        var b = bodyOf(g);
        if (b) { b.removeAttribute('role'); b.removeAttribute('aria-labelledby'); b.removeAttribute('tabindex'); }
        g.hidden = false;
        g.open = desktop ? true : (defaults[i] || g.dataset.userOpened === '1');
      });
    }
  }
  groups.forEach(function (d) { d.addEventListener('toggle', function () { if (!mq.matches) d.dataset.userOpened = d.open ? '1' : '0'; }); });
  tabs.forEach(function (t, i) {
    t.addEventListener('click', function () { activate(t.getAttribute('aria-controls'), false); t.focus(); });
    t.addEventListener('keydown', function (e) {
      var n = null;
      if (e.key === 'ArrowRight') n = (i + 1) % tabs.length;
      else if (e.key === 'ArrowLeft') n = (i - 1 + tabs.length) % tabs.length;
      else if (e.key === 'Home') n = 0;
      else if (e.key === 'End') n = tabs.length - 1;
      if (n === null) return;
      e.preventDefault();
      activate(tabs[n].getAttribute('aria-controls'), true);
    });
  });
  // links and hashes into a group: activate its tab, then let the accordion logic open any nested <details>
  var baseReveal = window.AmeAcc && window.AmeAcc.reveal;
  window.AmeAcc = window.AmeAcc || {};
  window.AmeAcc.reveal = function (el) {
    var g = el && el.closest ? el.closest('details.ame-acc--group') : null;
    if (g) activate(g.id, false);
    if (baseReveal) baseReveal(el);
  };
  window.AmeAcc.activate = activate;
  apply();
  if (mq.addEventListener) mq.addEventListener('change', apply); else if (mq.addListener) mq.addListener(apply);
  if (location.hash && location.hash.length > 1) {
    var hashed = null; try { hashed = document.getElementById(decodeURIComponent(location.hash.slice(1))); } catch (err) { hashed = null; }
    if (hashed) window.AmeAcc.reveal(hashed);
  }
})();

/* 2026-10-10 (PDP UX standardization): a legacy description table wider than its column scrolls sideways inside
   .ame-pdp-story__body (ame-pdp.css overflow-x:auto). A scroll container with no focusable content is unreachable from the
   keyboard (axe scrollable-region-focusable, measured on the PR-531 and the Jazzy EVO 614), so each such table becomes a
   named, focusable region. Tables that fit are left alone. Re-checked after a resize because the condition depends on width. */
(function () {
  var mark = function () {
    document.querySelectorAll('.ame-pdp .ame-acc__panel table').forEach(function (t) {
      var scrolls = t.scrollWidth > t.clientWidth + 2;
      if (scrolls && !t.hasAttribute('tabindex')) {
        t.setAttribute('tabindex', '0'); t.setAttribute('role', 'region');
        var cap = t.querySelector('caption'); var acc = t.closest('details.ame-acc'); var title = acc && acc.querySelector('.ame-acc__title');
        t.setAttribute('aria-label', (cap && cap.textContent.trim()) || ((title ? title.textContent.trim() + ' ' : '') + 'table (scrolls sideways)'));
      } else if (!scrolls && t.getAttribute('tabindex') === '0' && t.getAttribute('role') === 'region') {
        t.removeAttribute('tabindex'); t.removeAttribute('role'); t.removeAttribute('aria-label');
      }
    });
  };
  mark(); window.addEventListener('resize', mark); document.addEventListener('toggle', mark, true);
})();
